/* eslint-disable max-lines-per-function */
//#region  Start Scope: Import
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { FormattedMessage, injectIntl } from 'react-intl';
import { dateDiff } from '../../../../utils/consts/months';
import propTypes from 'prop-types';
import {
  returnFlightDate,
  returnFormatTime,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';

import '../flightInformation/flightInformation.scss';
import { TimeComponent } from '../mobileTicket/timeComponent';
//#endregion
class TicketFlightDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelrules: '',
      showCancelRuleModal: false,
      showLoading: false,
      selectedIndex: -1,
    };
  }

  //#region Start Scope:Render
  //show airline logo if we have the logo else show fix icon

  renderDetails = (flight, ind, list, list2) => {
    let { user } = this.props,
      showProvider = false,
      stakeholder = localStorage.getItem('stakeholder');

    if (user?.userInfo?.profiles) {
      let profiles = user?.userInfo?.profiles
        .map((t) => t.profile)
        .filter((t) => t.displayName.en === process.env.AGENCY_NAME);
      if (profiles.map((item) => item.id).includes(parseInt(stakeholder)))
        showProvider = true;
    }

    return (
      <div className="m-0 p-0 pt-1 pb-1 font-weight-bold d-flex flex-wrap w-100">
        <React.Fragment key={`frg-${ind}`}>
          <div
            className="px-0 m-0 col-12 font-weight-bold d-flex flex-row  "
            key={`flight-${ind}`}
          >
            {this.renderFlighPrimaryInfo(flight, ind, ind)}
          </div>
        </React.Fragment>
      </div>
    );
  };

  // render card for detil of each fligh
  renderDetailFrame = (flights, tickets, isModal, itineraries) => {
    let { detail, index } = this.props;
    if (flights && detail) {
      let { direction, name } = this.props.language;
      return (
        <div className="d-flex flex-column w-100 p-0  ">
          {detail.map((item, ind) => {
            return (
              <React.Fragment key={`flightDetails-${index}-${ind}`}>
                <div
                  className={`col-12 p-0 font-weight-bold d-flex flex-column   `}
                >
                  {/* ---------------------------------------------------------------------------------------- */}
                  {this.renderDetails(item, ind)}

                  {detail.length > 1 &&
                    index + 1 <= detail.length &&
                    detail[ind + 1] && (
                      <div className=" d-flex px-0 py-2 m-0 flex-row font-smaller justify-content-center">
                        <div className="d-flex flex-end col-2  p-0">
                          <hr
                            style={{ borderBottom: 'dashed 3px' }}
                            className="col-12 p-0 bg-white border-third border-top-0"
                            size="1"
                          />
                        </div>
                        <div
                          className="d-flex px-3 p-0 border-third"
                          style={{
                            backgroundColor: 'white',
                            borderRadius: 8,
                            borderWidth: 1,
                            borderStyle: 'solid',
                          }}
                        >
                          <div className="d-flex  px-4 py-2 ">
                            <span className="d-flex  align-items-center text-third text-third px-1">
                              <FormattedMessage
                                id="booking.stopdurationin"
                                defaultMessage="booking.stopdurationin"
                              />
                            </span>
                            <span className="d-flex text-secondary align-items-center  font-smaller ">{`${item.arrivalAirport.name[name]} : `}</span>
                            <span className="d-flex text-secondary align-items-center  px-1">
                              {detail.length > 1 &&
                                index + 1 <= detail.length &&
                                detail[ind + 1] &&
                                ` ${returnFormatTime(
                                  dateDiff(
                                    detail[ind + 1].departureDateTime,
                                    detail[ind].arrivalDateTime,
                                  ),
                                  direction,
                                  this.props.intl,
                                )}`}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex p-0 flex-end col-2">
                          <hr
                            style={{ borderBottom: 'dashed 3px' }}
                            className="col-12 p-0 bg-white border-third border-top-0"
                            size="1"
                          />
                        </div>
                      </div>
                    )}
                </div>

                {detail.length - 1 !== ind &&
                !(
                  detail.length > 1 &&
                  index + 1 <= detail.length &&
                  detail[ind + 1]
                ) ? (
                  <hr className="col-9 border border-2 border-bottom border-third" />
                ) : (
                  <></>
                )}
              </React.Fragment>
            );
          })}
        </div>
      );
    } else return null;
  };
  // render flight detail information
  renderFlightDetails = (item, index, ind) => {
    let { name, direction } = this.props.language,
      resBookDesigCabinName = item.bookingClassAvails
        ? item.bookingClassAvails.resBookDesigCabinName
        : item.resBookDesigCabinName;

    return (
      <div className="col-1 p-0 m-0 d-flex flex-column justify-content-center align-items-center">
        <div className="d-flex w-100">
          <div className="col-6 p-0 text-center text-uppercase font-weight-bold font-xsmall">
            <div
              className={`${'text-third'} text-center`}
              style={{ color: '#aaacaf ' }}
            >
              <FormattedMessage
                id="booking.travelclass"
                defaultMessage="booking.travelclass"
              />
            </div>
            <div
              className="text-center"
              style={{ color: '#b80089', direction }}
            >
              {` ${resBookDesigCabinName && resBookDesigCabinName[name]}`}
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render main info in detail box for each flight
  renderFlighPrimaryInfo = (item, index, ind) => {
    // console.log("test item", item);
    const { tickets } = this.props;
    let { name, direction } = this.props.language,
      diffTime =
        new Date(item.arrivalDateTime.split('T')[0]).getTime() -
        new Date(item.departureDateTime.split('T')[0]).getTime();
    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)),
      departureAirportName = ` ${item.departureAirport.name[name]
        .replace('فرودگاه', '')
        .replace('Airport', '')}`,
      departureTerminaltName = `${
        item.departureAirport.terminal
          ? `${this.props.intl.formatMessage({
              id: 'booking.terminal',
            })} ${item.departureAirport.terminal}`
          : this.props.intl.formatMessage({
              id: 'booking.mainterminal',
            })
      }`,
      arrivalAirportName = `${item.arrivalAirport.name[name]
        .replace('فرودگاه', '')
        .replace('Airport', '')}`,
      arrivalTerminalName = `${
        item.arrivalAirport.terminal
          ? `${this.props.intl.formatMessage({
              id: 'booking.terminal',
            })} ${item.arrivalAirport.terminal}`
          : this.props.intl.formatMessage({ id: 'booking.mainterminal' })
      }`;
    return (
      <div className="col-12 p-0 d-flex flex-row justify-content-between">
        <div
          className=" font-xsmall d-flex flex-column align-items-start justify-content-center p-0"
          style={{ width: '17%' }}
        >
          <div>
            <FormattedMessage
              id="booking.tickettitle"
              defaultMessage="booking.travelclass"
            />
            <span className="text-third">
              {tickets?.[this.props.index]?.ticketNumber}
            </span>
          </div>
          <div className="text-start">
            <FormattedMessage id="booking.referencenumber" />:
            <span className="text-third">
              {tickets?.[this.props.index]?.pnr}
            </span>
          </div>
        </div>
        <div
          className=" d-flex flex-column justify-content-center align-items-start px-1 "
          style={{ width: '15%' }}
        >
          <div className="d-flex justify-content-center font-weight-bold  align-items-center font-medium  text-primary   ">
            {item.departureAirport.cityName[name]}
          </div>
          <div
            id={`airportCodeDepart-${ind}-${index}`}
            style={{ color: '#aaacaf' }}
            className={`pointer d-flex text-truncate
                  justify-content-center
             font-weight-bold text-center  text-muted align-items-center ${
               departureAirportName.length > 22 ? 'font-tiny' : 'font-smaller'
             } `}
          >
            {departureAirportName}
          </div>
          <span className="font-smaller text-third ">
            {departureTerminaltName}
          </span>
        </div>
        <div
          className=" d-flex flex-row justify-content-center align-items-center px-0 "
          style={{ width: '31%' }}
        >
          {this.renderFlightDetailRouteImage(item, index)}
        </div>
        <div
          className=" d-flex flex-column justify-content-center align-items-start px-1  "
          style={{ width: '16%' }}
        >
          <div
            className={`d-flex justify-content-center align-items-center font-weight-bold text-primary
              font-medium
             `}
          >
            {item.arrivalAirport.cityName[name]}
          </div>
          <div
            id={`airportCodeArrive-${ind}-${index}`}
            className={`d-flex pointer 
						
								 justify-content-center
						 font-weight-bold align-items-center text-muted text-center ${
               arrivalAirportName.length > 22 ? 'font-tiny' : 'font-smaller'
             }`}
          >
            {arrivalAirportName}
          </div>
          <span className="font-smaller text-third">{arrivalTerminalName}</span>

          {direction === 'ltr' && (
            <div
              className={`px-1 d-flex justify-content-center text-uppercase text-third font-xsmall `}
            >
              {returnFlightDate(item.arrivalDateTime, 'en', this.props.intl)}
            </div>
          )}
        </div>
        <div
          className=" d-flex flex-column justify-content-center p-0 font-smaller"
          style={{ width: '15%' }}
        >
          <div className="w-100 d-flex  justify-content-center align-items-center  text-primary  p-0 ">
            {`${
              item.bookingClassAvails
                ? item.bookingClassAvails.resBookDesigCabinName[name]
                : item.resBookDesigCabinName[name]
            } (${
              item.bookingClassAvails
                ? item.bookingClassAvails.resBookDesigCode
                : item.resBookDesigCode
            })`}
          </div>
          <div className="w-100 d-flex  justify-content-around align-items-center text-secondary  p-0 ">
            {item.equipment.name[name] === '*' || !item.equipment.name[name]
              ? '--'
              : item.equipment.name[name]}
          </div>
          <div className="w-100 d-flex  justify-content-around align-items-center text-secondary p-0 ">
            {`${item.baggage[0].quantity} ${
              item.baggage[0].unit === 'KG' && direction === 'ltr'
                ? item.baggage[0].unit
                : direction === 'ltr'
                ? 'KG'
                : 'کیلوگرم'
            }`}
          </div>
        </div>
      </div>
    );
  };

  // show airplane and route with line to show airports data
  renderFlightDetailRouteImage = (item, index) => {
    let { flights } = this.props;
    // console.log("flight test tickets", flights, index);
    let { name, direction } = this.props.language,
      diffTime =
        new Date(item.arrivalDateTime.split('T')[0]).getTime() -
        new Date(item.departureDateTime.split('T')[0]).getTime();
    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)),
      departureAirportName = ` ${item.departureAirport.name[name]
        .replace('فرودگاه', '')
        .replace('Airport', '')} (${
        item.departureAirport.terminal
          ? `${this.props.intl.formatMessage({
              id: 'booking.terminal',
            })} ${item.departureAirport.terminal}`
          : this.props.intl.formatMessage({
              id: 'booking.mainterminal',
            })
      })`;
    return (
      <div className="d-flex w-100 h-100 justify-content-center ">
        <div className="d-flex  text-secondary justify-content-center font-weight-bold ondary align-items-center font-large">
          {`${item.departureDateTime.split('T')[1].substring(0, 5)} `}
        </div>

        <div className="">
          <div className="d-flex justify-content-center align-items-center py-0 px-2 m-0 w-100 font-xsmall">
            <span
              className={`p-1 font-weight-bold font-smaller ${
                flights?.itineraries?.[index]?.isCharte
                  ? 'text-danger'
                  : 'systemType-text'
              }  `}
            >
              <FormattedMessage
                id={`booking.${
                  flights?.itineraries?.[index]?.isCharter
                    ? 'charter'
                    : 'systemic'
                }`}
                defaultMessage={`booking.${
                  flights?.itineraries?.[index]?.isCharter
                    ? 'charter'
                    : 'systemic'
                }`}
              />
            </span>
            <span
              className={`font-smaller text-nowrap py-1 ${
                item.resBookDesigCabinName['en'] === 'Economy'
                  ? 'text-third  '
                  : 'text-warning'
              } font-weight-bold `}
            >
              {` - ${item.resBookDesigCabinName[name]}`}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className="d-flex w-100 px-4">
              <TimeComponent
                direction={direction}
                intl={this.props.intl}
                flightDuration={item.flightDuration.substring(0, 5)}
              />
            </div>
          </div>
          {this.renderFlightNumber(item)}
        </div>
        <div
          className={`d-flex justify-content-center text-center font-weight-bold ondary align-items-center  font-large
           `}
          style={{ direction, color: '#b80089' }}
        >
          {`${item.arrivalDateTime.split('T')[1].substring(0, 5)} ${
            diffDays > 0
              ? `(+${diffDays})`
              : diffDays < 0
              ? `(${diffDays})`
              : ''
          } 
               
            `}
        </div>
      </div>
    );
  };
  renderFlightNumber(item) {
    return (
      <div className="d-flex text-centerfont-smaller w-100 align-items-center ">
        <div
          style={{ color: '#7b4397' }}
          className={`d-flex ondary justify-content-center  font-smaller
          w-100  `}
        >
          <span className="text-third text-center">
            {`${this.props.intl.formatMessage({
              id: 'booking.flightnumber',
              defaultMessage: 'booking.flightnumber',
            })} `}
            <span
              className="ondary font-smaller"
              style={{ color: '#b80089' }}
            >{` ${item.flightNumber}`}</span>
          </span>
        </div>
      </div>
    );
  }
  // show marketing Airline for name of airline
  renderAirplaneIconDetail(flight, ind) {
    let { name } = this.props.language;
    let airlineCode = '';
    airlineCode = flight.operatingAirline.code
      ? flight.operatingAirline.code
      : 'Airplane';
    return (
      <div
        className={`d-flex flex-column align-items-center justify-content-center col-1 p-0 m-0 `}
      >
        <img
          className={`d-flex justify-content-center`}
          style={{ width: 35, height: 35 }}
          src={returnAirlineLogos(airlineCode)}
          alt="airlineCode"
        />

        <div className="d-flex justify-content-center align-items-center font-xsmall text-center font-weight-bold p-1 text-secondary">
          {flight.operatingAirline.name[name]}
        </div>
      </div>
    );
  }

  render() {
    return this.renderDetailFrame(this.props.flights, this.props.tickets);
  }
  //#endregion
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state.user,
  };
}

TicketFlightDetails.propTypes = {
  bookingId: propTypes.string,
  showPrice: propTypes.bool,
  intl: propTypes.object,
  tickets: propTypes.array,
  flights: propTypes.object,
  flightType: propTypes.string,
  isModal: propTypes.bool,
  isBooking: propTypes.bool,
};
TicketFlightDetails.defaultProps = {
  bookingId: '1',
  showPrice: false,
  intl: {},
  tickets: [],
  flights: {},
  flightType: '',
  isModal: false,
  isBooking: false,
};
export default injectIntl(
  connect(mapStateToProps)(withRouter(TicketFlightDetails)),
);
